import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { placeholder: String }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["remove_button"],
      create: false,
      closeAfterSelect: false,
      hideSelected: true,
      placeholder: this.placeholderValue || "Selecione uma ou mais opções"
    })
  }

  disconnect() {
    this.select?.destroy()
    this.select = null
  }
}
